export const getInitialDuration = (duration?: number | null): string => {
  if (!duration) return "1-hour";
  
  if (duration === 30) return "30-min";
  if (duration === 60) return "1-hour";
  if (duration === 120) return "2-hours";
  
  return "custom";
}; 